import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Receipt = () => {
  return <ErpTablePage moduleKey="inv_receipt" />;
};

export default Receipt;